import { FC } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Tooltip } from 'core-components/library/tooltip'
import { SupportButton } from 'partner360/components/supportButton'

import { TRANSLATION_KEYS } from '../../TranslationKeys'

interface IQuickStartButtonProps {
  link: string

  className?: string
}

export const QuickStartButton: FC<IQuickStartButtonProps> = ({ className, link }) => {
  return (
    <Tooltip tipContent={() => <Translation text={TRANSLATION_KEYS.quickStartButtonTooltip} />}>
      <SupportButton
        disabled={!link}
        icon="kbase kbase-document"
        className={className}
        to={link}
        target="_blank"
      >
        <Translation text={TRANSLATION_KEYS.quickStartButton} />
      </SupportButton>
    </Tooltip>
  )
}
